// extracted by mini-css-extract-plugin
export default {"root":"root__bdb75aaa","title":"title__bdb75aaa","commission":"commission__bdb75aaa","sdk_container":"sdk_container__bdb75aaa"};